/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Rag_Art_NoteInputs */

const en_svc_rag_art_note = /** @type {(inputs: Svc_Rag_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrative answer. Your documents define the detail.`)
};

const lv_svc_rag_art_note = /** @type {(inputs: Svc_Rag_Art_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilustratīva atbilde. Detaļas nosaka Jūsu dokumenti.`)
};

/**
* | output |
* | --- |
* | "Illustrative answer. Your documents define the detail." |
*
* @param {Svc_Rag_Art_NoteInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const svc_rag_art_note = /** @type {((inputs?: Svc_Rag_Art_NoteInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Rag_Art_NoteInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_svc_rag_art_note(inputs)
	return en_svc_rag_art_note(inputs)
});